import _ from 'lodash';

const MINIMUM_COLUMNS = 4;
const DOB_INDEX       = 3;
const DATE_REGEX      = /^([1-9]|0[1-9]|1[0-2])?\/([1-9]|0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

function makeError(line, message) {
  return { line: line + 1, message };
}

function cleanup(members) {
  return _.compact(members.map((m) => {
    // trim each value
    const values = m.map(col => col.trim());

    // ignore blank lines and lines with all blank values
    if (values.every(val => val === '')) {
      return null;
    }

    return values;
  }));
}

function validate(members) {
  return _.compact(_.map(members, (m, i) => {
    if (m.length < MINIMUM_COLUMNS) {
      return makeError(i, `CSV must contain at least ${MINIMUM_COLUMNS} columns`);
    }
    for (let col = 0; col < MINIMUM_COLUMNS; col++) {
      if (!m[col] || m[col].length === 0) {
        const letter = String.fromCharCode('A'.charCodeAt(0) + col);
        return makeError(i, `Value in column ${letter} must not be blank`);
      }
    }
    if (!DATE_REGEX.test(m[DOB_INDEX])) {
      return makeError(i, 'Date must be in format MM/DD/YYYY');
    }
    return null;
  }));
}

export default {
  cleanup,
  validate
};
